import { render, staticRenderFns } from "./UploadPointList.vue?vue&type=template&id=370dae73&"
import script from "./UploadPointList.vue?vue&type=script&lang=js&"
export * from "./UploadPointList.vue?vue&type=script&lang=js&"
import style0 from "./UploadPointList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports